import React from "react";
import { useHistory } from "react-router-dom";

const BtnGoBack = () => {
  const history = useHistory();

  return (
    <button className="btn btn-dark mt-5" onClick={history.goBack}>
      Back
    </button>
  );
};

export default BtnGoBack;
